import { AccountClassificationService } from '@/modules/global-settings/onboarder/services/account-classification.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the AccountClassificationService class
const accountClassificationService = new AccountClassificationService();
/// Define the state of the AccountClassification module
export const state = {
  accountClassifications: [],
  accountClasses: []
};
// Define the mutations of the AccountClassification module
export const mutations = {
  ...make.mutations(state),

  SET_ACCOUNT_CLASSIFICATIONS: (state, payload) => {
    state.accountClassifications = payload;
  },

  SET_ACCOUNT_CLASSES: (state, payload) => {
    state.accountClasses = payload;
  }
};
// Define the actions of the AccountClassification module
export const actions = {
  /**
   * Get account classes
   * @param {Object} object - Vuex context
   * @returns {Array} Array of account classes
   * @private This will set the values in state after fetching
   */
  fetchAccountClasses: async ({ dispatch, commit }) => {
    try {
      const { data } = await accountClassificationService.fetchAccountClasses();
      //Check if the data is empty
      if (!data || (data && data.length === 0)) {
        const { data: cData } = await dispatch('createAccountClass');
        commit('SET_ACCOUNT_CLASSES', cData);
        return cData;
      }
      commit('SET_ACCOUNT_CLASSES', data);
      return data;
    } catch (error) {
      Logger.error('fetching account classes');
      throw error;
    }
  },

  /**
   * Create account class
   * @param {Object} object - Vuex context
   * @returns {Array} Array of account classes
   * @private This will re-fetch the account classes after creating
   */
  createAccountClass: async ({ dispatch }) => {
    try {
      const result = await accountClassificationService.createAccountClass();
      dispatch('fetchAccountClasses');
      return result;
    } catch (error) {
      Logger.error('create account class');
      throw error;
    }
  },

  /**
   * Update account class
   * @param {Object} object - Vuex context
   * @param {Object} payload - Account class object
   * @param {String} payload.id - Account class id
   * @param {Object} payload.payload - Account class payload
   * @returns {void}
   * @private This will re-fetch the account classes after updating
   */
  updateAccountClass: async ({ dispatch }, { id, payload }) => {
    try {
      await accountClassificationService.updateAccountClass(id, payload);
      dispatch('fetchAccountClasses');
    } catch (error) {
      Logger.error('updating account class');
      throw error;
    }
  },

  /**
   * Get account classifications
   * @param {Object} object - Vuex context
   * @returns {Array} Array of account classifications
   * @private This will set the values in state after fetching
   */
  fetchAccountClassifications: async ({ dispatch, commit }) => {
    try {
      const { data } =
        await accountClassificationService.fetchAccountClassifications();
      //Check if the data is empty
      if (!data || (data && data.length === 0)) {
        const { data: cData } = await dispatch('createAccountClassification');
        commit('SET_ACCOUNT_CLASSIFICATIONS', cData);
        return cData;
      }
      commit('SET_ACCOUNT_CLASSIFICATIONS', data);
      return data;
    } catch (error) {
      Logger.error('fetching account classification');
      throw error;
    }
  },

  /**
   * Create account classification
   * @param {Object} object - Vuex context
   * @returns {Array} Array of account classifications
   * @private This will re-fetch the account classifications after creating
   */
  createAccountClassification: async ({ dispatch }, payload) => {
    try {
      const { data } =
        await accountClassificationService.createAccountClassification(payload);
      dispatch('fetchAccountClassifications');
      return data;
    } catch (error) {
      Logger.error('create account classification');
      throw error;
    }
  },

  /**
   * Update account classification
   * @param {Object} object - Vuex context
   * @param {Object} payload - Account classification object
   * @param {String} payload.id - Account classification id
   * @param {Object} payload.payload - Account classification payload
   * @returns {void}
   * @private This will re-fetch the account classifications after updating
   */
  updateAccountClassification: async ({ dispatch }, { id, payload }) => {
    try {
      await accountClassificationService.updateAccountClassification(
        id,
        payload
      );
      dispatch('fetchAccountClassifications');
    } catch (error) {
      Logger.error('updating account classification');
      throw error;
    }
  }
};
// Define the getters of the AccountClassification module
export const getters = {
  ...make.getters(state),
  activeAccountClassifications(state) {
    return state.accountClassifications.filter((a) => a.active == true);
  },
  activeAccountClasses(state) {
    return state.accountClasses.filter((a) => a.active == true);
  }
};
